import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=0c8a67c0&scoped=true"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=0c8a67c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a67c0",
  null
  
)

export default component.exports